import { render, staticRenderFns } from "./DhcpsnoopingClient.vue?vue&type=template&id=486f4e92&"
import script from "./DhcpsnoopingClient.vue?vue&type=script&lang=js&"
export * from "./DhcpsnoopingClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports